import { render, staticRenderFns } from "./Install.Detail.vue?vue&type=template&id=2b6f436e&"
import script from "./Install.Detail.vue?vue&type=script&lang=js&"
export * from "./Install.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports